module.exports = __webpack_public_path__ + "static/media/sf_200.0dffa087904bc78b446c7594275b796e.png";